import React from 'react'
import chenjiajia from '../../../imgs/chenjiajia.png'
import chenyiru from '../../../imgs/chenyiru.png'
import dali from '../../../imgs/dali.png'
import fangfanghentiaoshi from '../../../imgs/fangfanghentiaoshi.png'
import guoshaoyun from '../../../imgs/guoshaoyun.png'
import jianailiang from '../../../imgs/jianailiang.png'
import lixuanzhuo from '../../../imgs/lixuanzhuo.png'
import liyanan from '../../../imgs/liyanan.png'
import louyixiao from '../../../imgs/louyixiao.png'
import meishaonvhaigo from '../../../imgs/meishaonvhaigo.png'
import nihongjie from '../../../imgs/nihongjie.png'
import qiye from '../../../imgs/qiye.png'
import shentao from '../../../imgs/shentao.png'
import tangyuzhe from '../../../imgs/tangyuzhe.png'
import wangzulan from '../../../imgs/wangzulan.png'
import zhaoyazhi from '../../../imgs/zhaoyazhi.png'
import xuebao from '../../../imgs/xuebao.png'
import yinger from '../../../imgs/yinger.png'
import yudagongzi from '../../../imgs/yudagongzi.png'
import zhangbozhi from '../../../imgs/zhangbozhi.png'
import huangxinchun from '../../../imgs/huangxinchun.png'
import huangshengyi from '../../../imgs/huangshengyi.png'
import wuyating from '../../../imgs/wuyating.png'
import zhangyuxi from '../../../imgs/zhangyuxi.png'
import dongzhe from '../../../imgs/dongzhe.png'
import xiaowu from '../../../imgs/xiaowu.png'
import huangyouming from '../../../imgs/huangyouming.png'
import gaoxiaopan from '../../../imgs/gaoxiaopan.png'
import huangyi from '../../../imgs/huangyi.png'
import xuhaiwei from '../../../imgs/xuhaiwei.png'
import nibaoyijia from '../../../imgs/nibaoyijia.png'
import enjia from '../../../imgs/enjia.png'
import huangzitao from '../../../imgs/huangzitao.png'
import xuyiyang from '../../../imgs/xuyiyang.png'
import mengjia from '../../../imgs/mengjia.png'
import wenggefufu from '../../../imgs/wenggefufu.png'
import huangying from '../../../imgs/huangying.png'
import yangzi from '../../../imgs/yangzi.png'
import zhengxiuyan from '../../../imgs/zhengxiuyan.png'
import xiazhiyuan from '../../../imgs/xiazhiyuan.png'
import lifei from '../../../imgs/lifei.png'
import shabaoliang from '../../../imgs/shabaoliang.png'
import jiangchao from '../../../imgs/jiangchao.png'
import maidina from '../../../imgs/maidina.png'
import wenyifan from '../../../imgs/wenyifan.png'
import lige from '../../../imgs/lige.png'
import qiansongni from '../../../imgs/qiansongni.png'
import lixiaofeng from '../../../imgs/lixiaofeng.png'
import anhu from '../../../imgs/anhu.png'
import hewenna from '../../../imgs/hewenna.png'
import wangyuheng from '../../../imgs/wangyuheng.png'
import renhao from '../../../imgs/renhao.png'
import boyuan from '../../../imgs/boyuan.png'
import zhengkai from '../../../imgs/zhengkai.png'
import chebaoluo from '../../../imgs/chebaoluo.png'
import chenyihan from '../../../imgs/chenyihan.png'
import wuzhixiong from '../../../imgs/wuzhixiong.png'
import kele from '../../../imgs/kele.png'
import wangyuepeng from '../../../imgs/wangyuepeng.png'
import daning from '../../../imgs/daning.png'
import liwenhan from '../../../imgs/liwenhan.png'
import wuxuanyi from '../../../imgs/wuxuanyi.png'
import zhuzhengting from '../../../imgs/zhuzhengting.png'
import biwenjun from '../../../imgs/biwenjun.png'
import jinzihan from '../../../imgs/jinzihan.png'

import './index.less';

function CooperativeStar() {
  const [selectedTab, setSelectedTab] = React.useState(1)

  const handleClickTab = (type: number) => {
    if (type !== selectedTab) {
      setSelectedTab(type)
    }
  }

  const RedPerson = ({img, name, desc} : {img: string, name: string, desc: string | React.ReactNode}) => (
    <div className='red-person-container'>
      <div className='red-person'>
        <img src={img} alt='头像' className='avatar'/>
        <div>
          <p>{name}</p>
          <p>{desc}</p>
        </div>
      </div>
    </div>
  )

  return (
    <div className="cooperative-star-wrapper">
      <div className="tab-content">
        <div
          className={selectedTab === 1 ? 'selected-item' : 'item'}
          onClick={() => {
            handleClickTab(1)
          }}
        >
          合作艺人
        </div>
        <div
          className={selectedTab === 2 ? 'selected-item' : 'item'}
          onClick={() => {
            handleClickTab(2)
          }}
        >
          主播达人
        </div>
        <div
          className={selectedTab === 3 ? 'selected-item' : 'item'}
          onClick={() => {
            handleClickTab(3)
          }}
        >
          望望龙
        </div>
      </div>
      {selectedTab === 1 && (
        <div className='red-persons'>
          <RedPerson img={wangzulan} name="王祖蓝" desc="演员、歌手、主持人" />
          <RedPerson img={liyanan} name="李亚男" desc="演员" />
          <RedPerson img={chenjiajia} name="陈嘉佳" desc="演员" />
          <RedPerson img={zhangyuxi} name="张予曦" desc="演员、模特" />
          <RedPerson img={zhangbozhi} name="张柏芝" desc="演员、歌手" />
          <RedPerson img={guoshaoyun} name="郭少芸" desc="演员" />
          <RedPerson img={yinger} name="颖儿" desc="演员" />
          {/* <RedPerson img={xiongziqi} name="熊梓淇" desc="演员" /> */}
          <RedPerson img={louyixiao} name="娄艺潇" desc="演员、歌手" />
          <RedPerson img={nihongjie} name="倪虹洁" desc="演员、模特" />
          <RedPerson img={shentao} name="沈涛" desc="主持人" />
          <RedPerson img={chenyiru} name="辰亦儒" desc="歌手、演员、主持人" />
          <RedPerson img={jianailiang} name="贾乃亮" desc="演员" />
          <RedPerson img={tangyuzhe} name="唐禹哲" desc="歌手、演员" />
          <RedPerson img={huangxinchun} name="黄新淳" desc="歌手" />
          {/* <RedPerson img={hehongshan} name="何泓姗" desc="演员、模特、歌手" /> */}
          <RedPerson img={wuyating} name="吴雅婷Iris" desc={<>&nbsp;</>} />
          <RedPerson img={mengjia} name="孟佳" desc="歌手、演员" />
          <RedPerson img={wenggefufu} name="温格夫妇" desc="主持人" />
          <RedPerson img={huangying} name="黄英" desc="歌手" />
          <RedPerson
            img={huangshengyi}
            name="黄圣依"
            desc="演员、歌手、出品人"
          />
          <RedPerson img={yangzi} name="杨子" desc="收藏家、出品人、演员" />
          <RedPerson img={huangyouming} name="黄宥明" desc="演员、歌手" />
          <RedPerson img={gaoxiaopan} name="高晓攀" desc="演员、导演、编剧" />
          <RedPerson img={huangyi} name="黄奕" desc="演员、歌手" />
          <RedPerson
            img={zhengxiuyan}
            name="郑秀妍 Jessica"
            desc="歌手、演员"
          />
          <RedPerson img={chenyihan} name="陈意涵" desc="歌手、演员" />
          <RedPerson img={xuhaiwei} name="徐海为" desc="演员" />
          <RedPerson img={xiazhiyuan} name="夏志远" desc="演员、歌手" />
          <RedPerson img={lifei} name="李飞" desc="演员" />
          <RedPerson img={shabaoliang} name="沙宝亮" desc="歌手、演员" />
          <RedPerson img={wangyuheng} name="王昱珩" desc="设计师、南极大使" />
          <RedPerson img={jiangchao} name="姜潮" desc="歌手、演员" />
          <RedPerson img={maidina} name="麦迪娜" desc="演员" />
          <RedPerson img={wenyifan} name="文苡帆" desc="演员、歌手" />
          <RedPerson img={lixiaofeng} name="李晓峰" desc="演员、主持人、歌手" />
          <RedPerson img={anhu} name="安琥" desc="演员、歌手、主持人" />
          <RedPerson img={zhaoyazhi} name="赵雅芝" desc="演员" />
          <RedPerson img={hewenna} name="何雯娜夫妇" desc="奥运冠军、金牌制作人" />
          <RedPerson img={renhao} name="任豪" desc="演员、歌手" />
          <RedPerson img={boyuan} name="伯远" desc="歌手" />
          <RedPerson img={zhengkai} name="郑恺" desc="演员" />
          <RedPerson img={chebaoluo} name="车保罗" desc="演员" />
          <RedPerson img={liwenhan} name="李汶翰" desc="歌手、演员" />
          <RedPerson img={wuxuanyi} name="吴宣仪" desc="演员、歌手" />
          <RedPerson img={zhuzhengting} name="朱正廷" desc="演员、歌手、舞者" />
          <RedPerson img={biwenjun} name="毕雯珺" desc="演员、歌手" />
          <RedPerson img={jinzihan} name="金子涵" desc="歌手、演员、NAME组合成员" />
        </div>
      )}
      {selectedTab === 2 && (
        <>
          <div className='red-persons'>
            <RedPerson img={yudagongzi} name="瑜大公子" desc="" />
            <RedPerson img={lixuanzhuo} name="李宣卓" desc="" />
            <RedPerson img={lige} name="利哥很靠谱" desc="" />
            {/* <RedPerson img={naitiguli} name="乃提" desc="" /> */}
            <RedPerson img={fangfanghentiaoshi} name="芳芳很挑食" desc="" />
            <RedPerson img={dongzhe} name="董哲" desc="" />
            <RedPerson img={xuebao} name="雪宝" desc="" />
            {/* <RedPerson img={huzige} name="胡子哥" desc="" /> */}
            <RedPerson img={nibaoyijia} name="妮宝一家" desc="" />
            <RedPerson img={meishaonvhaigo} name="美少女嗨购go" desc="" />
            <RedPerson img={dali} name="大利" desc="" />
            <RedPerson img={xiaowu} name="小五" desc="" />
            <br />
            {/* <RedPerson img={xueouni} name="雪欧尼" desc="" /> */}
            <RedPerson img={qiansongni} name="千颂妮" desc="" />
            <RedPerson img={enjia} name="恩佳" desc="" />
            <RedPerson img={kele} name="可乐daydayup" desc="" />
            <RedPerson img={wangyuepeng} name="王岳鹏Niko" desc="" />
            <RedPerson img={daning} name="大柠Darling" desc="" />
          </div>
        </>
      )}
      {selectedTab === 3 && (
        <div className='red-persons'>
          <RedPerson img={huangzitao} name="黄子韬" desc="望望龙董事长" />
          <RedPerson img={xuyiyang} name="徐艺洋" desc="歌手、演员" />
          <RedPerson img={wuzhixiong} name="吴志雄" desc="演员" />
          <RedPerson img={qiye} name="七爷" desc="珠宝主播" />
        </div>
      )}
    </div>
  )
}

export default CooperativeStar

